// breakpoint settings

export const MOBILE_BREAKPOINT = 1024
export const NAV_MOBILE_BREAKPOINT = MOBILE_BREAKPOINT
